import { Component, OnDestroy } from '@angular/core';
import { ContactFormData, LinkRef } from '@kion/data-models';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UsersFacade } from '@kion/data-access/data-access-users';
import { CorrelationObserverService } from '@kion/ngrx-helper';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@kion/ui';
import { Checkbox } from '../../../../../../shared/ui/src/lib/shared/elements/checkbox/checkbox.component';
import { Router } from '@angular/router';
import { CmsConfig } from '../../config/cms.config';
import { SubSink } from 'subsink';

@Component({
  selector: 'kion-cms-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnDestroy{


  formData$: BehaviorSubject<ContactFormData> = new BehaviorSubject<ContactFormData>(null);
  checkboxSelected$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  checkbox: Checkbox;

  sending: boolean;

  private readonly subSink: SubSink;

  constructor(
    private usersFacade: UsersFacade,
    private observer: CorrelationObserverService,
    private translateService: TranslateService,
    private toastService: ToastService,
    private router: Router,
    private cmsConfig: CmsConfig
  ) {
    this.subSink = new SubSink();
    const link = '<a href="' + this.cmsConfig.basePath + this.cmsConfig.routes?.privacyPolicyBaseRoute + '" target="_blank">' + this.translateService.instant('contact.checkbox.privacy.link') + '</a>'
    this.checkbox = {
      title: this.translateService.instant('contact.checkbox.privacy.description', {link: link}),
      isLink: false,
      required: true,
      checked: false,
      titleAsHtml: true
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  get canProceed$(): Observable<boolean> {
    return combineLatest(
      [
        this.formData$,
        this.checkboxSelected$
      ]
    ).pipe(
      map(
        ([formData, selected]) => {
          return !!formData && selected;
        }
      )
    )
  }

  formChanged(formData: ContactFormData) {
    this.formData$.next(formData);
  }

  sendMessage() {
    this.sending = true;
    this.subSink.sink = this.observer.subscribeToAction(
      this.usersFacade.submitContactForm(this.formData$.value),
      () => {
        this.router.navigate(
          [
            this.cmsConfig.routes?.faqBaseRoute,
            this.cmsConfig.routes?.faqRoutes?.contactRoute,
            this.cmsConfig.routes?.faqRoutes?.confirmRoute
          ]
        ).then(() => { });
        this.sending = false;
      },
      () => {
        this.sending = false;
        this.toastService.show(
          {
            type: 'error',
            text: this.translateService.instant('forms.contact.toast.submit.error')
          }
        )
      }
    )
  }

  checkboxSelected(selected: boolean) {
    this.checkboxSelected$.next(selected);
  }
}
